import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../redux/slices/authSlice";

export default function useAutoLogout(timeoutMinutes = 30) {
  const dispatch = useDispatch();
  const timeout = timeoutMinutes * 60 * 1000;

  useEffect(() => {
    let timer;

    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        dispatch(logout());
      }, timeout);
    };

    // BUG FIX: removed "mousemove" — fires hundreds of times/sec on desktop,
    // and is completely irrelevant on mobile (this is a mobile-first app).
    // "touchstart" already covers mobile activity.
    const events = ["click", "keydown", "scroll", "touchstart"];

    events.forEach((event) => window.addEventListener(event, resetTimer, { passive: true }));
    resetTimer();

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      clearTimeout(timer);
    };
  }, [dispatch, timeout]);
}